function joinURLParams(filterParams: Record<string, any>, url: string): string {
  let firstParamExist = url.includes('?');

  for (const property in filterParams) {
    if (filterParams[property] !== null && filterParams[property] !== undefined) {
      const trimmedValue = filterParams[property].toString().trim();
      const encodedValue = encodeURIComponent(trimmedValue);
      url += firstParamExist ? `&${property}=${encodedValue}` : `?${property}=${encodedValue}`;
      firstParamExist = true;
    }
  }

  return url;
}

export default joinURLParams;
